import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ConfirmModal from "components/ConfirmModal";
import DragDropCtx from "components/DragDropCtx";
import DraggableList from "components/DragDropCtx/DraggableList";

import Placeholder from "./Placeholder";
import Block from "./Block";

import Button from "ui/Button";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutline";

import ElementModal from "./ElementModal";

import { emptyPageElement } from "utils/pageElements/constants";
import { usePageElementEditor } from "utils/pageElements/hooks";

const SocialLinksEditor = ({ socials, onSave }) => {

  const {
    pageElements,
    setPageElements,
    pageElement,
    setPageElement,
    deletingPageElement,
    setDeletingPageElement,
    elementModal,
    setElementModal,

    handleDelete,
    handleDragEnd,
    handleUpdate,
    handleCreate,
    handleModalClose,
    createElementState,
  } = usePageElementEditor(
    socials,
    onSave,
    Block,
  );

  const handleChange = ({ target: { name, value } }) => {
    setPageElement({ ...pageElement, [name]: value });
  };

  const handleCreateRequest = async () => {
    const newElement = { ...emptyPageElement, element_type: "social" };
    setPageElement(newElement);
    setElementModal(true);
  };

  useEffect(() => {
    setPageElements(createElementState(socials));
  }, [socials]);

  return (
    <>
      {pageElements?.length > 0 ? (
        <>
          <DragDropCtx handleDragEnd={handleDragEnd}>
            <DraggableList data={pageElements} droppableId="pageElements" />
          </DragDropCtx>
          <Button text small icon={AddCircleOutlineOutlinedIcon} onClick={handleCreateRequest}>
            Add New Platform
          </Button>
        </>
      ) : (
        <Placeholder onClick={handleCreateRequest} />
      )}

      {elementModal && (
        <ElementModal
          open={elementModal}
          onClose={handleModalClose}
          onSubmit={pageElement?.id ? handleUpdate : handleCreate}
          pageElement={pageElement}
          onChange={handleChange}
        />
      )}

      <ConfirmModal
        title={deletingPageElement && "Delete Social Link?"}
        open={deletingPageElement}
        onConfirm={handleDelete}
        setOpen={setDeletingPageElement}
      >
        Are you sure you want to delete this link block?
      </ConfirmModal>
    </>
  );
};

SocialLinksEditor.propTypes = {
  socials: PropTypes.array,
  onSave: PropTypes.func,
};

export default SocialLinksEditor;
